import { Values } from '../utils/types';

export const TASK_TYPE_STATUS = {
  ACTIVE: 'active',
  ARCHIVED: 'archived',
} as const;
export type TaskTypeStatus = Values<typeof TASK_TYPE_STATUS>;

export const PHYTO_TASK_TYPE_GROUP = 'phyto_group';
